import { Client } from '../clients/aasServerClient.generated';



export function uploadXML(hostname: string, secure: boolean, workspaceId: string, data: FormData) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.postXMLDatabase(workspaceId,hostname,secure,data);
}

export function getImportProgress() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getXMLDatabaseProgress();
}

export function getImportKey(hostname: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getServerKey(hostname);
}